export default __webpack_public_path__ + "9df44f2f70c19a7349d0ee2a080bc681.svg";